import errors from './errors/index.js';
import translation from './translation/index.js';
const pt_pt = {
    translation,
    errors,
};
export default Object.freeze(pt_pt);
